import React from "react";
import "./Pricing.css";
import NavbarClass from "../NavbarClass";
import Footer from "../footer/Footer";
import { connect } from "react-redux";

import { initiatePayment, verifyPayment, initiateOneTimePayment } from "../../actions/paymentActions";
import PricingCard from "./PricingCard";
import { getOrderAmount, loadScript } from "../../utils";
import { pageview } from "../../utils/googleAnalyticsUtils";
import { getUserCountry } from "../../actions/userActions";
import { InView } from "react-intersection-observer";

class Pricing extends React.Component {
  state = {
    loggedIn: false,
    premium: true,
    paymentIssueModalMessage: "",
    paymentIssueModalShow: false,
    showPaypalButton: false
  };

  async componentDidMount() {
    await this.props.getUserCountry();
    this.setState({
      showPaypalButton: this.props?.locationData?.countryCode ? (this.props?.locationData?.countryCode !== 'IN') : false
    })
    pageview("Pricing");
    const res = await loadScript(
      "https://checkout.razorpay.com/v1/checkout.js"
    );

    if (!res) {
      alert("Razorpay failed to load. Are you online?");
      return;
    }
  }

  displayRazorpay = async (plan = "MONTHLY") => {
    // change this to axios
    await this.props.initiatePayment(plan);
    const data = this.props.paymentData;
    console.log(data);
    if (!this.props.error && data) {
      const options = {
        key:
          process.env.REACT_APP_RAZORPAY_ENV === "development"
            ? process.env.REACT_APP_RAZORPAY_TEST_KEY_ID
            : process.env.REACT_APP_RAZORPAY_KEY_ID,
        subscription_id: data?.data?.subscriptionId,
        handler: this.props.verifyPayment,
        prefill: {
          email: data?.data?.userEmail,
        },
        theme: {
          color: "#F37254",
        },
      };

      console.log(options);

      const paymentObject = new window.Razorpay(options);
      paymentObject.open();
    }
  };

  displayRazorpayPaypal = async (plan = "MONTHLY") => {
    // change this to axios
    await this.props.initiateOneTimePayment(plan);
    const data = this.props.paymentData;

    if (!this.props.error && data) {
      const options = {
        key: process.env.REACT_APP_RAZORPAY_ENV === "development"
            ? process.env.REACT_APP_RAZORPAY_TEST_KEY_ID
            : process.env.REACT_APP_RAZORPAY_KEY_ID,
        handler: this.props.verifyPayment,
        order_id: data?.data?.orderId,
        currency: "USD",
        amount: getOrderAmount(plan),
        prefill: {
          email: data?.data?.userEmail,
        },
        theme: {
          color: "#F37254",
        },
        config: {
          display: {
            blocks: {
              banks: {
                name: "Paypal",
                instruments: [
                  {
                    method: "wallet",
                    wallets: ["paypal"],
                  },
                ],
              },
            },
            sequence: ["block.banks"],
            preferences: {
              show_default_blocks: false,
            },
          },
        },
      };
  
      const paymentObject = new window.Razorpay(options);
      paymentObject.open();
    }
    
    // }
  };

  render() {
    return (
      <div
        style={{
          position: "relative",
          minHeight: "100vh",
          // paddingBottom: "5.6rem",
        }}
      >
        <NavbarClass handleSignInOpen={this.props.handleSignInOpen} />
        <div className="text-center">
          <picture>
            <source
              width="1800"
              height="360"
              media="(min-width: 768px)"
              srcSet={`${process.env.REACT_APP_AWS_IMG_CDN}/banners/pricing_header_pc.webp`}
              alt="It is an image which reads a quote by Warren Buffet: 'Price is what you pay. Value is what you get'. It also has a cupcake and chocolate wafer as a weighing scale. One side of the wafer has 'price' cloud sitting on it, while the other side has 'value' cloud on it. The value cloud side of the scale is weighed down, indicating value has more weight than price."
            />
            <img
              width="800"
              height="400"
              src={`${process.env.REACT_APP_AWS_IMG_CDN}/banners/pricing_header_mob.webp`}
              className="w-100"
              alt="Reads a quote by Warren Buffet: 'Price is what you pay. Value is what you get'. It also has a cupcake and chocolate wafer as a weighing scale. One side of the wafer has 'price' cloud sitting on it, while the other side has 'value' cloud on it. The value cloud side of the scale is weighed down, indicating value has more weight than price."
            ></img>
          </picture>
        </div>
        <div className="container">
          <div className="pricing-page-text text-center display-4">
            <h2 className="hp-section-heading text-center">What's included</h2>
            <div className="row pricing-page-feature-outer-container">
              <div className="col-lg-3 col-md-6 col-12 pricing-page-feature-container">
                <i className="fa fa-3x fa-video-camera" aria-hidden="true"></i>
                <p className="pricing-page-feature-heading">
                  Entertaining videos based on values for kids
                </p>
              </div>

              <div className="col-lg-3 col-md-6 col-12 pricing-page-feature-container">
                {" "}
                <i className="fa fa-3x fa-check-circle" aria-hidden="true"></i>
                <p className="pricing-page-feature-heading">
                  Interesting activities to enable implementation of values
                </p>
              </div>
              <div className="col-lg-3 col-md-6 col-12 pricing-page-feature-container">
                {" "}
                <i className="fa fa-3x fa-book" aria-hidden="true"></i>
                <p className="pricing-page-feature-heading">
                  Unique moral stories to read to your children
                </p>
              </div>
              <div className="col-lg-3 col-md-6 col-12 pricing-page-feature-container">
                {" "}
                <i className="fa fa-3x fa-user-friends" aria-hidden="true"></i>
                <p className="pricing-page-feature-heading">
                  Daily email to parents with watched video scripts
                </p>
              </div>
            </div>
          </div>
          <div className="text-center w-100 pricing-sub-heading mb-3 mt-4">
            <h2 className="hp-section-heading text-center">Subscription Plans</h2>
          </div>
          <InView threshold={0.1} triggerOnce>
            {({ inView, ref }) => (
              <div ref={ref} className={`pricing-cards-container hp-animate hp-animate--up ${inView ? "is-visible" : ""}`}>
                <PricingCard
                  period="Monthly"
                  discountedPrice="99"
                  originalPrice="149"
                  pricePeriod="mo"
                  planName="Small Scoop"
                  product_id={"MONTHLY"}
                  intiatePayment={this.displayRazorpay}
                  intiatePaypalPayment={this.displayRazorpayPaypal}
                  showPaypalButton={this.state.showPaypalButton}
                />
                <PricingCard
                  period="Quarterly"
                  discountedPrice="249"
                  originalPrice="399"
                  pricePeriod="3mos"
                  planName="Medium Scoop"
                  product_id={"QUARTERLY"}
                  intiatePayment={this.displayRazorpay}
                  intiatePaypalPayment={this.displayRazorpayPaypal}
                  showPaypalButton={this.state.showPaypalButton}
                  middle
                  recommended
                />
                <PricingCard
                  period="Annually"
                  discountedPrice="949"
                  originalPrice="1399"
                  pricePeriod="yr"
                  planName="Large Scoop"
                  intiatePayment={this.displayRazorpay}
                  intiatePaypalPayment={this.displayRazorpayPaypal}
                  showPaypalButton={this.state.showPaypalButton}
                  product_id={"ANNUALLY"}
                />
              </div>
            )}
          </InView>
          <div
            style={{ width: "100%", textAlign: "center", marginBottom: "2rem" }}
          ></div>
          {/* <PricingCard />
          <PricingCard /> */}
        </div>
        <Footer customStyles={{ position: "absolute", bottom: 0 }}></Footer>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    paymentData: state.payment.paymentData,
    error: state.payment.error,
    locationData: state.userLocation.locationData
  };
};

export default connect(mapStateToProps, {
  initiatePayment,
  verifyPayment,
  getUserCountry,
  initiateOneTimePayment
})(Pricing);
